/**
 * Created by cahyo wibowo on 1/4/19
 */

import {capitalize, startCase} from 'lodash';

export default (value: string) => {
	return startCase(capitalize(value));
}
